import {
  apiFrontendServiceLandingCountryspecificRetrieve,
  apiFrontendServiceLandingRetrieve,
  getApiFrontendServiceLandingCountryspecificRetrieveQueryKey,
  getApiFrontendServiceLandingRetrieveQueryKey,
  ServiceLanding,
  useApiFrontendServiceLandingCountryspecificRetrieve,
  useApiFrontendServiceLandingRetrieve,
} from '@rover/rsdk/src/apiClient/latest';
import {
  CountryUrlPrefix,
  US_COUNTRY_URL_PREFIX,
} from '@rover/shared/js/constants/roverGeo.constants';

export function getServiceLandingFetchArgs(
  countryUrlPrefix: string,
  serviceLandingSlug: string
): {
  queryKey: ReturnType<
    | typeof getApiFrontendServiceLandingCountryspecificRetrieveQueryKey
    | typeof getApiFrontendServiceLandingRetrieveQueryKey
  >;
  queryFn: () => ReturnType<
    | typeof apiFrontendServiceLandingCountryspecificRetrieve
    | typeof apiFrontendServiceLandingRetrieve
  >;
} {
  const isCountrySpecific = countryUrlPrefix !== US_COUNTRY_URL_PREFIX;
  return isCountrySpecific
    ? {
        queryKey: getApiFrontendServiceLandingCountryspecificRetrieveQueryKey(
          countryUrlPrefix,
          serviceLandingSlug
        ),
        queryFn: () =>
          apiFrontendServiceLandingCountryspecificRetrieve(countryUrlPrefix, serviceLandingSlug),
      }
    : {
        queryKey: getApiFrontendServiceLandingRetrieveQueryKey(serviceLandingSlug),
        queryFn: () => apiFrontendServiceLandingRetrieve(serviceLandingSlug),
      };
}

const useServiceLanding = (
  countryUrlPrefix: CountryUrlPrefix,
  serviceLandingSlug: string
): ReturnType<
  | typeof useApiFrontendServiceLandingCountryspecificRetrieve<ServiceLanding>
  | typeof useApiFrontendServiceLandingRetrieve<ServiceLanding>
> => {
  const isCountrySpecific = countryUrlPrefix !== US_COUNTRY_URL_PREFIX;

  const countrySpecificServiceLanding = useApiFrontendServiceLandingCountryspecificRetrieve(
    countryUrlPrefix,
    serviceLandingSlug,
    {
      query: { enabled: isCountrySpecific },
    }
  );
  const nonCountrySpecificServiceLanding = useApiFrontendServiceLandingRetrieve(
    serviceLandingSlug,
    {
      query: { enabled: !isCountrySpecific },
    }
  );
  return isCountrySpecific ? countrySpecificServiceLanding : nonCountrySpecificServiceLanding;
};

export default useServiceLanding;
